import './adx';
import './ao';
import './aroon';
import './atr';
import './bb';
import './chandelierexit';
import './cci';
import './chop';
import './ema';
import './hma';
import './ichimokucloud';
import './kc';
import './kst';
import './macda';
import './psar';
import './roc';
import './rsi';
import './sma';
import './swma';
import './stochastic';
import './stochasticrsi';
import './supertrend';
import './tma';
import './trix';
import './wema';
import './williamsr';
import './wma';




// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/technicalanalysis/indicators/index.js